import React, { useEffect, useMemo, useReducer } from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icon from "../controls/Icon";
import Spinner from "../controls/Spinner";
export const PageButton = (props) => {
    const { namespace, page } = props;
    const [, forceUpdate] = useReducer((x) => x + 1, 0);
    const { t } = useTranslation();
    // Create a stable object to pass to attach/detach that triggers re-renders
    const updateHandle = useMemo(() => ({ forceUpdate }), []);
    useEffect(() => {
        if (page.badge) {
            page.badge.attach(updateHandle);
        }
        if (page.activity) {
            page.activity.attach(updateHandle);
        }
        return () => {
            if (page.badge) {
                page.badge.detach(updateHandle);
            }
            if (page.activity) {
                page.activity.detach(updateHandle);
            }
        };
    }, [page, updateHandle]);
    const renderBadge = () => {
        if (page.badge === undefined) {
            return null;
        }
        return React.createElement(Badge, null, page.badge.calculate());
    };
    const renderActivity = () => {
        if (page.activity === undefined || !page.activity.calculate()) {
            return null;
        }
        return React.createElement(Spinner, null);
    };
    return (React.createElement("div", null,
        React.createElement(Icon, { name: page.icon }),
        React.createElement("span", { className: "menu-label" }, t(page.title, { ns: namespace })),
        renderBadge(),
        renderActivity()));
};
export default PageButton;
